
import Component from '../../../assets/scripts/modules/component'
import fireCustomEvent from '../../../assets/scripts/utilities/fire-custom-event'

export default class MenuBarComponent extends Component {
  init () {
    this.buttonMenu = this.element.querySelector('.icon-button--menu')
    this.buttonMenu.addEventListener('click', () => fireCustomEvent('open-menu-overlay'))

    this.setupOverlay()
    this.enhanceSearchItem()
  }

  setupOverlay () {
    const listItems = this.element.querySelector('.menu-bar__links')

    listItems.addEventListener('click', e => {
      const menuLink = e.target.closest('.link')
      if (!menuLink) return
      const menuItem = menuLink.parentElement
      if (!menuItem.classList.contains('has-submenu')) return
      e.preventDefault()
      fireCustomEvent('open-menu-overlay', { detail: { itemNo: Array.prototype.indexOf.call(listItems.children, menuItem) + 1 } })
    })
  }

  enhanceSearchItem () {
    const listItem = this.element.querySelector('.menu-bar__link.variant-search')
    if (!listItem) return

    const shrink = e => {
      this.element.classList.remove('search-expanded')
    }

    const form = listItem.querySelector('form')
    const input = form.querySelector('input')
    const label = form.querySelector('label')
    const lbl = label.querySelector('.search-bar__label')
    const button = label.querySelector('button')

    // remove anchor (no-js)
    const a = lbl.children[0]
    lbl.innerHTML = a.innerHTML

    button.addEventListener('click', e => {
      e.preventDefault()
      e.stopPropagation()
      if (this.element.classList.contains('search-expanded')) {
        form.submit()
        return
      }
      label.click()
    })

    label.addEventListener('click', e => {
      e.stopPropagation()
      this.element.classList.add('search-expanded')

      window.setTimeout(() => {
        document.addEventListener('click', shrink, {
          once: true
        })
      }, 200)

      input.focus() // explicit focus (e.g. when button is clicked)
    })

    label.addEventListener('focusout', e => {
      if (input.value.trim() === '') { shrink(e) }
    })
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.menu-bar').forEach(element => {
  element.instance = element.instance || new MenuBarComponent(element)
}))
